import React, { useEffect, useState } from 'react'
import './adminSurvey.css'
import { useNavigate, useParams } from 'react-router-dom'
import { adminGetSurveyFormApi } from '../../../api/admin/survey';
import { useForm } from 'react-hook-form';
import { getFileName } from '../../../utils/file/file';
import { FaFileAlt } from "react-icons/fa";
import { swalErrorAlert } from '../../../utils/swal/swal';


const AdminSurveyFormRead = () => {
    /* Params */
    const { userId } = useParams();

    /* Navigate */
    const navigate = useNavigate()

    /* States */
    const [formInfo, setFormInfo] = useState(null)
    const [fileList, setFileList] = useState([])

    /* useEffect */
    useEffect(() => {
        getFormInfo(userId)
    }, [])


    /* Methods */
    const getFormInfo = async (userId) => {
        if (!userId) return

        try {
            const response = await adminGetSurveyFormApi(userId)
            if (response.status === 200) {
                const jsonData = response.data.resData.json_data
                const fileList = response.data.resData.files

                setFormInfo(jsonData)
                setFileList(fileList)
                return

            }
            else if (response.status === 204) {
                window.alert('작성된 신청서가 없습니다.')
                navigate('/hy-admin/survey')
                return
            }
            else { return false }
        } catch (error) {
            console.log(error);
            swalErrorAlert()
            return
        }
    }

    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">상담신청서 열람</h1>
            </div>

            {/* Content Row */}
            <div className="">
                <div className='survey-form-read mt-5'>
                    <SurveyFormSection formInfo={formInfo} fileList={fileList} />
                </div>
            </div>
        </div >
    )
}


const SurveyFormSection = ({ formInfo, fileList }) => {
    /* React Hook Form */
    const { register, reset } = useForm()

    /* useEffect */
    useEffect(() => {
        reset(formInfo)
    }, [formInfo])


    return (
        <div className='form-wrap card' style={{ padding: "60px 40px", border: "1px solid #e5e5e5" }}>
            <div className='mb-5'>
                <h2 className='h3 mb-3 text-center'>상담 신청서</h2>
            </div>
            <form className='survey-form'>
                <div className='mt-4 mb-4'>
                    <label htmlFor="userName" className="form-label required mb-3">1. 학생 이름</label>
                    <div className="input-group">
                        <input type="text" {...register('userName')} id="userName" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label className="form-label required mb-3">2. 성별</label>
                    <div className="input-group mb-5">
                        <div className="me-5">
                            <input type="radio" value={'남'} {...register("userSex")} id='userSexMale' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='userSexMale'>남</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'여'} {...register("userSex")} id='userSexFemale' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='userSexFemale'>여</label>
                        </div>
                    </div>
                </div>

                <div className='mb-4'>
                    <label className="form-label required mb-3">3. 학년</label>
                    <div className="input-group mb-5">
                        <div className="me-5">
                            <input type="radio" value={'9학년'} {...register("userGrade")} id='userGradeNine' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='userGradeNine'>9학년</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'10학년'} {...register("userGrade")} id='userGradeTen' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='userGradeTen'>10학년</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'11학년'} {...register("userGrade")} id='userGradeEleven' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='userGradeEleven'>11학년</label>
                        </div>
                    </div>
                </div>

                <div className='mt-4 mb-4'>
                    <label htmlFor="userEmailStudent" className="form-label required mb-3">4. 연락처(이메일주소)</label>

                    <div className="input-group mb-2">
                        <input type="email" {...register("userEmailStudent")} id="userEmailStudent" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-5">
                        <input type="email" {...register("userEmailParent")} id="userEmailParent" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label className="form-label required mb-3">5. 한국대학 지원자격</label>
                    <div className="input-group mb-5">
                        <div className="me-5">
                            <input type="radio" value={'12년특례'} {...register('applyType')} id='applyType1' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='applyType1'>12년특례</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'3년특례'} {...register('applyType')} id='applyType2' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='applyType2'>3년특례</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'수시 전형'} {...register('applyType')} id='applyType3' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='applyType3'>수시 전형</label>
                        </div>
                        <div className="me-5">
                            <input type="radio" value={'잘 모르겠음'} {...register('applyType')} id='applyType4' className="form-check-input mt-0 me-2" disabled />
                            <label htmlFor='radio-2-4'>잘 모르겠음</label>
                        </div>
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='hopeUniversity1' className="form-label required mb-3">6. 한국대학 희망대학</label>
                    <div className="input-group mb-2">
                        <input type="text" {...register('hopeUniversity1')} id="hopeUniversity1" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('hopeUniversity2')} id="hopeUniversity2" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-5">
                        <input type="text" {...register('hopeUniversity3')} id="hopeUniversity3" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='hopeMajor1' className="form-label required mb-3">7. 한국대학 희망전공, 계열</label>
                    <div className="input-group mb-2">
                        <input type="text" {...register('hopeMajor1')} id="hopeMajor1" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('hopeMajor2')} id="hopeMajor2" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-5">
                        <input type="text" {...register('hopeMajor3')} id="hopeMajor3" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label className="form-label required mb-2">8. 학교 성적(GPA) &nbsp;(성적표 업로드 필수)</label>

                    <div className='mb-1'><span className='font-size-sm'>(9학년부터 현재 학년까지 최근 성적을 모두 입력해주세요.)</span></div>
                    <div className='mb-3'><span className='font-size-sm'>(아래 첨부파일란에 성적표를 업로드 해주세요.)</span></div>

                    <div className="d-flex input-group mb-2">
                        <input type="text" {...register('gpaGrade1')} id="gpaGrade1" className="form-control" disabled />
                        <input type="text" {...register('gpaValue1')} id="gpaValue1" className="form-control" disabled />
                    </div>
                    <div className="d-flex input-group mb-2">
                        <input type="text" {...register('gpaGrade2')} id="gpaGrade2" className="form-control" disabled />
                        <input type="text" {...register('gpaValue2')} id="gpaValue2" className="form-control" disabled />
                    </div>
                    <div className="d-flex input-group mb-5">
                        <input type="text" {...register('gpaGrade3')} id="gpaGrade3" className="form-control" disabled />
                        <input type="text" {...register('gpaValue3')} id="gpaValue3" className="form-control" disabled />
                    </div>
                </div>


                <div className='mb-4'>
                    <label htmlFor='introduce' className="form-label required mb-3">9. '나'라는 사람은 어떤 사람인가요? (간단하게)</label>
                    <div className="input-group mb-2">
                        <textarea {...register('introduce')} id='introduce' className="form-control" rows={8} disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='achievement' className="form-label required mb-3">10. 본인이 가장 자랑스러워하는 성취는 무엇이며, 그 성취를 통해 배운 점은 무엇인가요?</label>
                    <div className="input-group mb-2">
                        <textarea {...register('achievement')} id='achievement' className="form-control" rows={8} disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='difficulty' className="form-label required mb-3">11. 당신이 직면했던 가장 큰 어려움이나 도전은 무엇이었으며, 그것을 어떻게 극복했나요?</label>
                    <div className="input-group mb-2">
                        <textarea {...register('difficulty')} id='difficulty' className="form-control" rows={8} disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='respect' className="form-label required mb-3">12. 가장 존경하는 인물은 누구이며, 그 이유는 무엇인가요?</label>
                    <div className="input-group mb-2">
                        <textarea {...register('respect')} id='respect' className="form-control" rows={8} disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='goals' className="form-label required mb-3">13. 인생에서 이루고 싶은 목표가 있다면 무엇이고, 그 목표를 달성하기 위해 어떤 계획을 세우고 있나요?</label>
                    <div className="input-group mb-2">
                        <textarea {...register('goals')} id='goals' className="form-control" rows={8} disabled />
                    </div>
                </div>

                <hr className='mt-5 mb-5' />

                <div className='mb-4'>
                    <p className='text-primary'>아래 문항부터는 선택 입력 항목입니다.</p>
                </div>

                <div className='mb-4'>
                    <label className="form-label mb-2">14. 공인 성적 (성적표 업로드)</label>
                    <div className='mb-3'><span className='font-size-sm'>(아래 첨부파일란에 성적표를 업로드 해주세요.)</span></div>
                    <div className='sub-section mb-4'>
                        <label htmlFor='languageTestName1' className="form-label mb-3">14-1. 공인 어학 성적 (TOEFL, IETLS 등)</label>

                        <div className="d-flex input-group mb-2">
                            <input type="text" {...register('languageTestName1')} id="languageTestName1" className="form-control" disabled />
                            <input type="text" {...register('languageTestValue1')} id="languageTestValue1" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <input type="text" {...register('languageTestName2')} id="languageTestName2" className="form-control" disabled />
                            <input type="text" {...register('languageTestValue2')} id="languageTestValue2" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <textarea {...register('languageTestAnother')} id='languageTestAnother' className="form-control" rows={4} disabled />
                        </div>
                    </div>

                    <div className='sub-section mb-4'>
                        <label htmlFor='standardTestName1' className="form-label mb-3">14-2. 표준화 학력 시험 (SAT, AP 등)</label>

                        <div className="d-flex input-group mb-2">
                            <textarea {...register('standardTestName1')} id="standardTestName1" className="form-control" disabled />
                            <textarea {...register('standardTestValue1')} id="standardTestValue1" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <textarea {...register('standardTestName2')} id="standardTestName2" className="form-control" disabled />
                            <textarea {...register('standardTestValue2')} id="standardTestValue2" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <textarea {...register('standardTestAnother')} id='standardTestAnother' className="form-control" rows={4} disabled />
                        </div>
                    </div>

                    <div className='sub-section mb-4'>
                        <label htmlFor='etcTestName1' className="form-label mb-3">14-3. 기타 공인 성적 (제2외국어 등)</label>
                        <div className="d-flex input-group mb-2">
                            <input type="text" {...register('etcTestName1')} id="etcTestName1" className="form-control" disabled />
                            <input type="text" {...register('etcTestValue1')} id="etcTestValue1" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <input type="text" {...register('etcTestName2')} id="etcTestName2" className="form-control" disabled />
                            <input type="text" {...register('etcTestValue2')} id="etcTestValue2" className="form-control" disabled />
                        </div>
                        <div className="d-flex input-group mb-2">
                            <textarea {...register('etcTestAnother')} id='etcTestAnother' className="form-control" rows={4} disabled />
                        </div>
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='club1' className="form-label mb-3">15. 주요 동아리 활동</label>
                    <div className="input-group mb-2">
                        <input type="text" {...register('club1')} id="club1" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('club2')} id="club2" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('club3')} id="club3" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='award1' className="form-label mb-3">16. 주요 수상 실적</label>
                    <div className="input-group mb-2">
                        <input type="text" {...register('award1')} id="award1" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('award2')} id="award2" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('award3')} id="award3" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='leadership1' className="form-label mb-3">17. 리더십 활동</label>
                    <div className="input-group mb-2">
                        <input type="text" {...register('leadership1')} id="leadership1" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('leadership2')} id="leadership2" className="form-control" disabled />
                    </div>
                    <div className="input-group mb-2">
                        <input type="text" {...register('leadership3')} id="leadership3" className="form-control" disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='question' className="form-label mb-3">18. 한국대학 입시관련 궁금한 점</label>
                    <div className="input-group mb-2">
                        <textarea {...register('question')} id='question' className="form-control" rows={14} maxLength={500} disabled />
                    </div>
                </div>

                <div className='mb-4'>
                    <label htmlFor='files' className="form-label mb-3">19. 첨부파일 업로드 (1.학교성적표, 2.어학성적표, 3.표준화학력시험 성적표, 4.기타공인성적 성적표, 5.동아리, 수상실적)</label>
                    <div className='files-section'>
                        {fileList && <FileListSection fileList={fileList} />}
                        {!fileList && <p>업로드된 첨부파일이 없습니다.</p>}
                    </div>
                </div>
            </form>
        </div>
    )
}

const FileListSection = ({ fileList }) => {
    return (
        <div>
            <ul>
                {fileList.map((file, index) => {
                    let fileName = getFileName('survey', file)
                    return <li key={'file-list-item-' + index}><a href={file} download={fileName}><FaFileAlt /> {fileName}</a></li>
                })}
            </ul>
        </div>
    )
}


export default AdminSurveyFormRead